import ContentResultsResearch from '@/ContentResultsResearch/ContentResultsResearch';
import Modals from '@/Modals';
import { NewPriceBanner } from '@/NewPrice';
import DeliveryBannerWrapper from '@/Search/components/DeliveryBannerWrapper';
import { ResultsSection } from '@/SearchResults/ResultsSection';
import BreadCrumbs from '@/SEO/BreadCrumbs';
import Filters from './Filters';
import { Container, FiltersResultsContainer, Main } from './MainLayout.styles';
import { SearchHeader, SearchTools } from './SearchHeader';
import MenuOptions from './SearchHeader/MenuOptions';

export default function MainLayout({ initialSeoProps }) {
  return (
    <div className="m-auto max-w-[1800px]">
      <DeliveryBannerWrapper />
      <Container>
        <FiltersResultsContainer>
          <Filters />
          <Main>
            <SearchHeader />
            <MenuOptions />
            <SearchTools />
            <div className="bg-grey-1 p-16 m:bg-white m:p-0">
              <NewPriceBanner />
              <ResultsSection />
            </div>
          </Main>
        </FiltersResultsContainer>
        <div className="bg-white flex flex-col h-[84px] mt-32 w-100">
          <div className="border-0 border-grey-2 border-solid border-t flex flex-col h-[100%] justify-center w-100">
            <BreadCrumbs />
          </div>
        </div>
      </Container>
      <Modals />
      <ContentResultsResearch initialSeoProps={initialSeoProps} />
    </div>
  );
}
